import React, { useState, useEffect } from "react";
import { Button, withField, Select, Tooltip } from "@douyinfe/semi-ui";
import { ReactComponent as BulbIcon } from "@assets/icons/bulb_icon.svg";
import { PROTEIN_BINDER_DESIGN_TYPES } from "@services/home/config/home.config";
import {
  DataTypeModel,
  ProteinBinderAttachmentModel,
} from "@services/home/model/home.model";
import { BinderDesignTypeEnum } from "@services/home/enum/home.enum";
import type { RenderSelectedItemFn } from "@douyinfe/semi-ui/lib/es/select";

import styles from "./index.module.scss";
import classNames from "classnames";

interface Prop {
  value?: ProteinBinderAttachmentModel;
  onChange?: (values: any) => void;
}

const ProteinBinderDesignAttachmentField: React.FC<Prop> = ({
  value,
  onChange,
}) => {
  const [selectedType, setSelectedType] = useState(
    PROTEIN_BINDER_DESIGN_TYPES[0].value
  );

  const [isDeepThink, setIsDeepThink] = useState(false);

  function onToggleDeepThink() {
    if (!onChange) {
      return;
    }

    setIsDeepThink(!isDeepThink);

    onChange({
      target_type: selectedType,
      deepthink: !isDeepThink,
    });
  }

  function onTypeChange(
    v: string | number | any[] | Record<string, any> | undefined
  ) {
    if (!onChange || typeof v !== "string") {
      return;
    }

    setSelectedType(v);

    onChange({
      target_type: v,
      deepthink: isDeepThink,
    });
  }

  const renderSelectedItem: RenderSelectedItemFn = (
    optionNode: Record<string, any>
  ) => {
    return optionNode.label;
  };

  const renderCustomOption = (item: DataTypeModel) => {
    return (
      <Select.Option value={item.value} showTick={false} key={item.value}>
        <item.icon />
        <div>{item.name}</div>
      </Select.Option>
    );
  };

  useEffect(() => {
    if (!value) {
      if (onChange) {
        onChange({
          target_type: selectedType,
          deepthink: isDeepThink,
        });
      }
    } else {
      setSelectedType(value.target_type);
      setIsDeepThink(value.deepthink);
    }
  }, [value]);

  return (
    <div className={styles.attachmentContainer}>
      <Tooltip content="Target biomolecule type" style={{ maxWidth: "unset" }}>
        <Select
          clickToHide
          className="select-btn"
          size="small"
          onChange={onTypeChange}
          value={selectedType}
          // defaultValue={BinderDesignTypeEnum.Ligand}
          renderSelectedItem={renderSelectedItem}
          dropdownClassName="select-dropdown"
        >
          {PROTEIN_BINDER_DESIGN_TYPES.map((item) => renderCustomOption(item))}
        </Select>
      </Tooltip>

      <Tooltip
        content="Think deeper for better design quality"
        style={{ maxWidth: "unset" }}
      >
        <Button
          style={{ marginLeft: "16px" }}
          onClick={onToggleDeepThink}
          className={classNames({
            "border-btn": true,
            active: isDeepThink,
          })}
          theme="light"
          type="tertiary"
          size="small"
          icon={<BulbIcon />}
        >
          DeepThink
        </Button>
      </Tooltip>
    </div>
  );
};

export default withField(ProteinBinderDesignAttachmentField);
